export default __webpack_public_path__ + "static/media/ruban-3.03e3a74d.png";